import React from 'react';
import ContactAddress from './ContactAddress';
import ContactMap from './ContactMap';
import ContactForm from './ContactForm';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-container">
      <div className="contact-grid">
        <ContactAddress />
        <ContactMap />
        <ContactForm />
      </div>
    </div>
  );
};

export default Contact;
